/* ============================================================
   BimbiVip · Halloween 26/10 – 01/11/2026
   Caricato SOLO in fase halloween (snippets/bbv-campaign.liquid, slot 'bar').
   - conto alla rovescia nella barra
   - favicon caramella
   - ragnetto che scende al primo scroll (1 volta per sessione)
   - ragnatela + ragnetto sulla galleria della scheda prodotto (solo prodotti in promo)
   - caramella che vola nel secchiello all'aggiunta al carrello
   - contatore 3 caramelle nel carrello (frammento /cart?view=bbv-hw)
   Tutto si ferma con "riduci movimento".
   ============================================================ */
(function () {
  var A = window.bbvHw || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ss(get, key, val) {
    try { if (get) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) { return null; }
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var els = document.querySelectorAll('[data-bbv-hw-cd]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], t = el.querySelector('[data-cd-txt]');
      var d = new Date(el.getAttribute('data-deadline')).getTime() - Date.now();
      if (!t) continue;
      if (d <= 0) { el.style.display = 'none'; continue; }
      var g = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4);
      t.textContent = (g > 0 ? g + 'g ' : '') + pad(h) + 'h ' + pad(m) + 'm';
    }
  }

  /* ---------- Favicon ---------- */
  function favicon() {
    if (!A.candyOrange) return;
    var links = document.querySelectorAll('link[rel~="icon"]');
    if (!links.length) {
      var l = document.createElement('link'); l.rel = 'icon'; document.head.appendChild(l); links = [l];
    }
    for (var i = 0; i < links.length; i++) { links[i].type = 'image/svg+xml'; links[i].href = A.candyOrange; }
  }

  /* ---------- Scheda prodotto: ragnatela + ragnetto sulla galleria ---------- */
  var SPIDER_SVG = '<svg viewBox="0 0 30 34" fill="none" stroke-linecap="round">' +
    '<g stroke="#2B2238" stroke-width="1.6"><path d="M10 12l-7-6M10 16l-8 0M10 20l-7 5M20 12l7-6M20 16l8 0M20 20l7 5"/></g>' +
    '<ellipse cx="15" cy="17" rx="6.5" ry="8" fill="#2B2238"/><circle cx="12.8" cy="14.5" r="1.4" fill="#fff"/><circle cx="17.2" cy="14.5" r="1.4" fill="#fff"/>' +
    '<path d="M12.5 20q2.5 1.6 5 0" stroke="#E8742A" stroke-width="1.2"/></svg>';
  function pdpDeco() {
    if (!document.querySelector('.bbv-hw-pdp')) return;            /* solo prodotti in promo */
    var host = document.querySelector('.media-gallery .main-image');
    if (!host || host.querySelector('.bbv-hw-deco')) return;
    var d = document.createElement('div');
    d.className = 'bbv-hw-deco';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<svg class="bbv-hw-web" viewBox="0 0 120 120" fill="none" stroke="#2B2238" stroke-linecap="round">' +
        '<g stroke-width="1.1" opacity=".55"><path d="M120 120L0 120M120 120L8 62M120 120L40 18M120 120L84 0M120 120L120 0"/></g>' +
        '<g stroke-width=".9" opacity=".45">' +
          '<path d="M96 120Q99 109 98 108Q104 103 104 98Q109 95 109 92Q111 93 120 96"/>' +
          '<path d="M70 120Q74 101 72 100Q85 90 86 84Q96 76 99 72Q104 72 120 70"/>' +
          '<path d="M42 120Q47 92 46 90Q66 76 66 68Q84 56 86 48Q96 46 120 44"/>' +
          '<path d="M16 120Q22 84 20 80Q46 60 46 52Q70 36 72 26Q90 22 120 18"/>' +
        '</g></svg>' +
      '<div class="bbv-hw-dangle"><span class="bbv-hw-dangle__thread"></span><button type="button" tabindex="-1" class="bbv-hw-dangle__spider">' + SPIDER_SVG + '</button></div>';
    host.appendChild(d);
    /* la ragnatela si appoggia all'angolo in basso dell'ultima foto visibile */
    function fit() {
      var hr = host.getBoundingClientRect(), maxB = 0;
      var ms = host.querySelectorAll('.product-media');
      for (var i = 0; i < ms.length; i++) {
        var r = ms[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.right <= hr.right + 2 && r.left >= hr.left - 2) maxB = Math.max(maxB, r.bottom);
      }
      d.style.bottom = maxB ? Math.max(0, Math.round(hr.bottom - maxB)) + 'px' : '0px';
    }
    fit(); setTimeout(fit, 800); window.addEventListener('resize', fit); window.addEventListener('load', fit);
    var dg = d.querySelector('.bbv-hw-dangle');
    if (reduce) { dg.classList.add('is-static'); return; }
    setTimeout(function () { dg.classList.add('is-down'); }, 600);
    dg.querySelector('button').addEventListener('click', function () {
      dg.classList.remove('is-down'); dg.classList.add('is-up');
    });
  }

  /* ---------- Ragnetto ---------- */
  function spider() {
    if (reduce || ss(true, 'bbv_hw_spider')) return;
    var shown = false;
    function show() {
      if (shown || window.scrollY < 120) return;
      shown = true;
      window.removeEventListener('scroll', show);
      ss(false, 'bbv_hw_spider', '1');
      var s = document.createElement('div');
      s.className = 'bbv-hw-spider';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<svg viewBox="0 0 30 130" fill="none" stroke-linecap="round"><path d="M15 0V104" stroke="#9C90AC" stroke-width="1.2"/>' +
        '<g stroke="#2B2238" stroke-width="1.6"><path d="M10 108l-7-6M10 112l-8 0M10 116l-7 5M20 108l7-6M20 112l8 0M20 116l7 5"/></g>' +
        '<ellipse cx="15" cy="113" rx="6.5" ry="8" fill="#2B2238"/><circle cx="12.8" cy="110.5" r="1.4" fill="#fff"/><circle cx="17.2" cy="110.5" r="1.4" fill="#fff"/>' +
        '<path d="M12.5 116q2.5 1.6 5 0" stroke="#E8742A" stroke-width="1.2"/></svg>' +
        '<button class="bbv-hw-spider__hit" type="button" tabindex="-1" aria-hidden="true"></button>';
      var hb = document.querySelector('.section-header');
      var top = hb ? Math.max(0, Math.round(hb.getBoundingClientRect().bottom)) : 0;
      s.style.top = top + 'px';
      document.body.appendChild(s);
      requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('is-down'); }); });
      function up() { s.classList.remove('is-down'); s.classList.add('is-up'); setTimeout(function () { s.remove(); }, 700); }
      s.querySelector('button').addEventListener('click', up);
      setTimeout(up, 9000);
    }
    window.addEventListener('scroll', show, { passive: true });
  }

  /* ---------- Caramella che vola nel secchiello ---------- */
  function visibleCartIcon() {
    var els = document.querySelectorAll('.cart-link__icon');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width && r.height && r.bottom > 0) return els[i];
    }
    return els[0] || null;
  }
  function fly(fromEl) {
    var target = visibleCartIcon();
    if (!target) return;
    if (reduce || !A.candy || !fromEl) { target.classList.add('bbv-hw-pop'); setTimeout(function(){ target.classList.remove('bbv-hw-pop'); }, 600); return; }
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var img = document.createElement('img');
    img.src = A.candy; img.alt = ''; img.className = 'bbv-hw-fly';
    img.style.left = (a.left + a.width / 2 - 17) + 'px';
    img.style.top = (a.top + a.height / 2 - 11) + 'px';
    document.body.appendChild(img);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(320deg) scale(.45)';
        img.style.opacity = '.4';
      });
    });
    setTimeout(function () {
      img.remove();
      target.classList.add('bbv-hw-pop');
      setTimeout(function () { target.classList.remove('bbv-hw-pop'); }, 600);
    }, 680);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    var btn = e.submitter || f.querySelector('[type="submit"]');
    fly(btn);
  }, true);


  /* ---------- Carrello: contatore 3 caramelle + testi "secchiello" ---------- */
  var meterBusy = false, meterTimer = null, mo = null;
  function texts() {
    var t = document.getElementById('CartDrawerModal-Title');
    if (t && t.firstChild && t.firstChild.nodeType === 3 && t.firstChild.nodeValue.indexOf('secchiello') === -1) {
      t.firstChild.nodeValue = 'Il tuo secchiello ';
    }
    var e = document.querySelector('.cart-drawer__empty-content .majortitle');
    if (e && e.textContent.indexOf('secchiello') === -1) {
      e.textContent = 'Il secchiello è vuoto.';
      var r = e.parentNode.querySelector('.rte');
      if (!r) { r = document.createElement('div'); r.className = 'rte'; e.parentNode.insertBefore(r, e.nextSibling); }
      r.innerHTML = '<p>Dolcetto o scherzetto? Riempilo con i nuovi arrivi.</p>';
    }
  }
  function hosts() {
    var out = [];
    var up = document.querySelectorAll('cart-drawer .cart-drawer__content-upper');
    for (var i = 0; i < up.length; i++) {
      var h = up[i].querySelector(':scope > .bbv-hw-meter-host');
      if (!h) {
        h = document.createElement('div');
        h.className = 'bbv-hw-meter-host cart-drawer__content-item';
        var head = up[i].querySelector('.cart-drawer__header');
        if (head && head.nextSibling) up[i].insertBefore(h, head.nextSibling); else up[i].appendChild(h);
      }
      out.push(h);
    }
    if (document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname)) {
      var list = document.querySelector('main .cart-item-list, #main .cart-item-list, main form[action*="/cart"]');
      if (list) {
        var hp = document.querySelector('.bbv-hw-meter-host--page');
        if (!hp) { hp = document.createElement('div'); hp.className = 'bbv-hw-meter-host bbv-hw-meter-host--page'; hp.style.margin = '0 0 16px'; list.parentNode.insertBefore(hp, list); }
        out.push(hp);
      }
    }
    return out;
  }
  function meter() {
    if (meterBusy) return;
    meterBusy = true;
    fetch('/cart?view=bbv-hw', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (mo) mo.disconnect();
        html = html.trim();
        var hs = hosts();
        for (var i = 0; i < hs.length; i++) if (hs[i].getAttribute('data-src') !== html) { hs[i].innerHTML = html; hs[i].setAttribute('data-src', html); }
        texts();
      })
      .catch(function () {})
      .then(function () { meterBusy = false; watch(); });
  }
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    if (!mo) mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (n.nodeType !== 1) n = n.parentNode;
        if (n && n.closest && n.closest('.bbv-hw-meter-host')) continue;
        clearTimeout(meterTimer); meterTimer = setTimeout(meter, 250); return;
      }
    });
    mo.observe(d, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    tick(); setInterval(tick, 30000);
    favicon();
    pdpDeco();
    spider();
    meter();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
